import { forwardRef, useCallback } from "react"
import { SelectX } from "web/components"
import { useFieldSuggestedValues } from "web/hooks/data"
import { isNotAValue } from "web/services/helpers"
import ControlContainer from "./ControlContainer"

const SingleValueListInput = forwardRef((props, ref) => {
  const {
    id,
    name,
    value,
    error,
    touched,
    onChange,
    onFocus,
    autoFocus,
    disabled = false,
  } = props

  const suggestedValues = useFieldSuggestedValues({ id })

  const encodedSuggestedValues = useCallback(
    async (hint) => {
      return (await suggestedValues(hint)).map((el) => ({
        value: el,
        label: el,
      }))
    },
    [suggestedValues]
  )

  const selectXValue =
    isNotAValue(value) || Array.isArray(value)
      ? {}
      : { ...value, label: value.value }

  return (
    <ControlContainer {...props} errorCondition={error && touched}>
      <SelectX
        ref={ref}
        name={name}
        value={selectXValue}
        suggestedValues={encodedSuggestedValues}
        onChange={(value) => onChange(value)}
        onFocus={onFocus}
        options={{
          multipleValues: false,
          inputClassName: "form-control",
          inputTestId: `form-input-${name}`,
          autoFocus,
          placeholder: "Select a value...",
        }}
        disabled={disabled}
      />
    </ControlContainer>
  )
})

export default SingleValueListInput
